import { render, staticRenderFns } from "./ChannelsTabs.vue?vue&type=template&id=2845d231&scoped=true"
import script from "./ChannelsTabs.vue?vue&type=script&lang=js"
export * from "./ChannelsTabs.vue?vue&type=script&lang=js"
import style0 from "./ChannelsTabs.vue?vue&type=style&index=0&id=2845d231&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2845d231",
  null
  
)

export default component.exports